/*
 * COPYRIGHT: EUMETSAT 2018
 * LICENSE: PROPRIETARY
 * PROJECT: WMS
 *
 * All information contained herein is, and remains the property of EUMETSAT.
 * Dissemination of this information or reproduction of this material is
 * strictly forbidden unless prior written permission is obtained from
 * EUMETSAT.
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { OAuthModule } from 'angular-oauth2-oidc';

import { MainRoutingModule } from './main-routing.module';
import { ConfigModule } from '../config/config.module';
import { LayoutModule } from '../layout/layout.module';

import { RootComponent, NavbarComponent, ApiKeysComponent } from './components';
import {
    UserService,  OAuthHttpInterceptor, OAuthScopedStorage, AuthResourceHandler, Wso2ApiService
} from './services';


@NgModule({
    declarations: [RootComponent, NavbarComponent, ApiKeysComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        CommonModule,
        FormsModule,
        ConfigModule.forRoot({url: 'assets/data/config.json'}),
        HttpClientModule,
        OAuthModule.forRoot(),
        LayoutModule,
        MainRoutingModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: OAuthHttpInterceptor,
            multi: true,
        },
        OAuthScopedStorage,
        AuthResourceHandler,
        UserService,
        Wso2ApiService
    ],
    bootstrap: [RootComponent]
})
export class MainModule {}



// WEBPACK FOOTER //
// ./src/main/main.module.ts